module.exports = __webpack_public_path__ + "static/location-2eca6b2f316b041f606c17c2f33052a3.svg";